<template>
  <div class="box12">
    <pageTitle 
      title="你是否还有以下疑问" 
      text=""
      titleColor="#332114"
      titColor="#332114"
    />
    <div class="content">
      <ul>
        <li class="item">
          <h3>报考条件</h3>
          <p><span>・</span>没有从业经验可以考吗？</p>
          <p><span>・</span>对年龄、学历有限制吗？</p>
        </li>
        <li class="item">
          <h3>考试费用</h3>
          <p><span>・</span>学费是否包含了报名费？</p>
          <p><span>・</span>报名费里有补考吗？</p>
        </li>
        <li class="item">
          <h3>考试难度</h3>
          <p><span>・</span>历年通过率高不高？</p>
          <p><span>・</span>考题范围有哪些？</p>
        </li>
        <li class="item">
          <h3>考试内容</h3>
          <p><span>・</span>考试大纲是什么？</p>
          <p><span>・</span>考试题型有哪些？</p>
        </li>
        <li class="item">
          <h3>考试结果</h3>
          <p><span>・</span>何时知道结果？</p>
          <p><span>・</span>在哪里查询结果？</p>
        </li>
        <li class="item">
          <h3>报考时间/地点</h3>
          <p><span>・</span>什么时候可以报名？</p>
          <p><span>・</span>考试的地点在哪里？</p>
        </li>
      </ul>
    </div>
    <div class="btn-box">
      <div class="btn" @click="zixun(1,'咨询学习顾问')">咨询学习顾问</div>
    </div>
  </div>
</template>

<script>
  import pageTitle from "../common/pageTitle.vue";
  export default {
    components: {
      pageTitle,
    },
    name: '',
    data() {
      return {
        
      }
    },
    methods:{
      zixun(type,item){
        type==1?  this.mai("阿里云大数据ACP认证课","咨询学习顾问",0,null): this.mai("阿里云大数据ACP认证课",item,0,null)
        this.clickZiXun()
      }
    }
  }
</script>

<style lang="scss" scoped>
.box12{
  padding: 80px 0;
  background-image: url(../../../assets/coursePage/acp/box12/bg.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.content {
  padding: 60px 30px 30px;
}
ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .item {
    width: calc(50% - 15px);
    height: 164px;
    background: url(../../../assets/coursePage/acp/box12/bg-card.png) no-repeat center;
    background-size: 100% 100%;
    margin-bottom: 30px;
    padding: 24px 0 0 30px;
    box-sizing: border-box;
    h3 {
      font-family: PingFangSC-Medium;
      font-size: 28px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 38px;
      letter-spacing: 0px;
      color: #ff6a00;
      margin-bottom: 10px;
    }
    p {
      font-family: PingFangSC-Regular;
      font-size: 24px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #332114;
      margin-left: -8px;
      span {
        color: #ff7f00;
        font-weight: 600;
      }
    }
  }
}
.btn-box{
  display: flex;
  justify-content: center;
  .btn{
    width: 630px;
    height: 88px;
    background-image: linear-gradient(0deg, 
      #ff8833 0%, 
      #ff6a00 100%);
    border-radius: 44px;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 88px;
    text-align: center;
  }
}
</style>